import React, { useEffect, useState } from "react";
import "../RoomDetails/RoomDetailsPage.css";
import { FaWifi } from "react-icons/fa6";
import { FaStar } from "react-icons/fa6";
import { TbAirConditioning } from "react-icons/tb";
import { FaPersonSwimming } from "react-icons/fa6";
import { RiFridgeLine } from "react-icons/ri";
import { BsFillSafe2Fill } from "react-icons/bs";
import { PiTelevisionSimpleBold } from "react-icons/pi";
import Footer from "../../Component/Footer/Footer";

import { Link, useParams, useNavigate, useLocation } from "react-router-dom";

import { DatePicker, Input, InputNumber, message, Progress } from "antd";
import moment from "moment/moment";
import { useBooking } from "../../context/BookingProvider";
import RoomData from "../RoomData";
import TextArea from "antd/es/input/TextArea";
import $ from "jquery"

const RoomDetailsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])
  const search = useLocation();
  const Path = search.pathname;

  const foundSubservice = RoomData.find((subservice) => subservice.slug === Path);

  console.log("foundSubservice", foundSubservice.roomName)


  const { room_id } = useParams(); // Get room_id from the URL
  const [roomDetails, setRoomDetails] = useState(null);
  const navigate = useNavigate(); // Initialize useNavigate
  const [availableRooms, setAvailableRooms] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [comment, setComment] = useState("");
  const [contact, setContact] = useState("");
  const [roomname, setRoomname] = useState("");

  const {
    checkInDate,
    setCheckInDate,
    checkOutDate,
    setCheckOutDate,
    adultQuantity,
    setAdultQuantity,
    childrenQuantity,
    setChildrenQuantity,
    roomsQuantity,
    setRoomsQuantity,
  } = useBooking();

  const handleAdultIncrement = () => {
    setAdultQuantity(prevQuantity => prevQuantity + 1);
  };

  const handleAdultDecrement = () => {
    if (adultQuantity > 1) {
      setAdultQuantity(prevQuantity => prevQuantity - 1);
    }
  };
  const handleRoomsIncrement = () => {
    setRoomsQuantity(prevQuantity => prevQuantity + 1);
  };

  const handleRoomsDecrement = () => {
    if (roomsQuantity > 1) {
      setRoomsQuantity(prevQuantity => prevQuantity - 1);
    }
  };

  // useEffect(() => {
  //   fetchRoomDetails();
  // }, [room_id]);

  const calculateRooms = () => {
    if (adultQuantity > 0) {
      setRoomsQuantity(Math.ceil(adultQuantity / 4));
    } else {
      setRoomsQuantity(0);
    }
  };

  useEffect(() => {
    calculateRooms();
  }, [adultQuantity])
  // const fetchRoomDetails = async () => {
  //   setLoading(true);
  //   try {
  //     const response = await fetch(
  //       `https//www.skdm.in/server/royal/room.php?action=roomFetch&room_id=${room_id}`
  //     );
  //     if (!response.ok) {
  //       throw new Error("Failed to fetch room details");
  //     }
  //     const data = await response.json();
  //     setRoomDetails(data);
  //   } catch (error) {
  //     setError(error.message);
  //   } finally {
  //     setLoading(false);
  //   }
  // };



  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  const handlechange = (value) => {
    setContact(value)
  }
  const handleBooking = async () => {
    if (!checkInDate || !checkOutDate) {
      alert("Please select both Check In and Check Out dates.");
      return;
    }

    if (formatDate(checkOutDate) > formatDate(checkInDate) || checkOutDate === checkInDate) {
      if (formatDate(checkInDate) >= formatDate(moment())) {


        // console.log(formatDate(checkInDate),formatDate(checkOutDate))
        const formData = new FormData();
        formData.append("action", "checkroomavailability");
        formData.append("start_date", formatDate(checkInDate));
        formData.append("end_date", formatDate(checkOutDate));
        formData.append("room_id", room_id); // Include room_id in the request

        try {
          setLoading(true);
          const response = await fetch(
            "https://www.skdm.in/server/royal/available_check.php",
            {
              method: "POST",
              body: formData,
            }
          );

          if (!response.ok) {
            throw new Error("Failed to check room availability");
          }

          const data = await response.json();
          setAvailableRooms(data);

          if (data.room) {
            navigate(`/booking/${room_id}`); // Navigate to booking if available
            message.success("Room is available! Proceed with booking.");
          } else {
            alert("Sorry, no rooms available for the selected dates.");
          }
        } catch (error) {
          setError(error.message);
        } finally {
          setLoading(false);
        }
      } else {
        message.error("Check In Date Cannot Be lesser than today")
        setCheckInDate('')
      }
    } else {
      message.error("Check Out Date Cannot Be lesser or Equal to CheckIn Date ")
      setCheckOutDate('')
    }
  };
  const submitForm = (event, values) => {
    event.preventDefault();
    if (String(contact).length !== 10) {
      message.error("Mobile Number Must Be Ten Digits")
    } else {
      // console.log("value", values)
      if (!checkInDate || !checkOutDate) {
        alert("Please select both Check In and Check Out dates.");
        return;
      }

      if (formatDate(checkOutDate) > formatDate(checkInDate) || checkOutDate === checkInDate) {
        if (formatDate(checkInDate) >= formatDate(moment())) {

          var body =
            "<!DOCTYPE html><html><head><title>Enquiry Lead</title></head><body><div style='font-family:Arial,sans-serif;max-width:600px;margin:0 auto;background-color:#f2f2f2;padding:20px'><h2 style='color:#821f40'>Seema's Resort</h2><p>Hello</p><p>Thank you for your interest in comment</p><p>Please check your comment which generated from website:</p><table cellpadding='5' style='margin:0'><tr><td style='text-align:left;color:#821f40'><strong>Name:</strong></td><td style='text-align:left'>" +
            name +
            '</td></tr><tr><td style="text-align:left;color:#821f40"><strong>Email Id:</strong></td><td style="text-align:left">' +
            email +
            '</td></tr><tr><td style="text-align:left;color:#821f40"><strong>Contact No:</strong></td><td style="text-align:left">' +
            contact +
            '</td></tr><tr><td style="text-align:left;color:#821f40"><strong>Message:</strong></td><td style="text-align:left">' +
            comment
            +
            '</td></tr><tr><td style="text-align:left;color:#821f40"><strong>Check In Date:</strong></td><td style="text-align:left">' +
            formatDate(checkInDate)
            +
            '</td></tr><tr><td style="text-align:left;color:#821f40"><strong>Check Out Date:</strong></td><td style="text-align:left">' +
            formatDate(checkOutDate)
            +
            '</td></tr><tr><td style="text-align:left;color:#821f40"><strong>No of Guests:</strong></td><td style="text-align:left">' +
            adultQuantity
            +
            '</td></tr><tr><td style="text-align:left;color:#821f40"><strong>No of Rooms:</strong></td><td style="text-align:left">' +
            roomsQuantity
            +
            '</td></tr><tr><td style="text-align:left;color:#821f40"><strong>Room Name:</strong></td><td style="text-align:left">' +
            roomname
            +
            "</td></tr></table><p style='font-weight:700'>Best regards,<br>Your Team at Seema's Resort</p></div></body></html>";

          $.post(
            "https://skdm.in/server/v1/send_lead_mail.php",
            {
              toEmail: "seemaresort@gmail.com",
              fromEmail: "skdmlead@gmail.com",
              bccMail: "skdmlead@gmail.com",
              mailSubject: "New Customer Lead",
              mailBody: body,
              accountName: "jutiepie",
              accountLeadSource: "",
              accountLeadName: name,
              accountLeadEmail: email,
              accountLeadPhone: contact,
            },

            function (dataa, status) {
              console.log("data :" + dataa);
              console.log("name:" + values);
            }
          );

          message.success("Your Form has Submitted Our team will contact with You  soon.");
          // form.resetFields();
          // values.preventDefault();
          // return false;
          setName("");
          setEmail("");
          setContact("");
          setComment("");
        } else {
          message.error("Check In Date Cannot Be lesser than today")
          setCheckInDate('')
        }
      } else {
        message.error("Check Out Date Cannot Be lesser or Equal to CheckIn Date ")
        setCheckOutDate('')
      }
    }
  };
  // const disabledCheckInDate = (current) =>
  //   current && (current < moment().startOf("day") || (checkOutDate && current > checkOutDate));

  // const disabledCheckOutDate = (current) =>
  //   current && (current < moment().startOf("day") || (checkInDate && current <= checkInDate));

  const handleCheckInChange = (date) => {
    setCheckInDate(date);
    if (moment(date).isAfter(checkOutDate)) {
      setCheckOutDate(null);
    }
  };

  const handleCheckOutChange = (date) => setCheckOutDate(date);

  if (loading) return <p>Loading room details...</p>;
  if (error) return <p>Error: {error}</p>;
  const primaryImage = foundSubservice.roomImageData.slice(0, 1)[0]; // First image
  console.log("primaryImage", primaryImage)
  const restImages = foundSubservice.roomImageData.slice(1); // Remaining images 

  const formatSlugToText = (slug = "") =>
    slug
      .replace("/", "")
      .replace(/-/g, " ")
      .replace(/\b\w/g, char => char.toUpperCase());

  return (
    <>
      <section className="Rooms-Section-Banner-Images">
        <div className="Rooms-Section-Banner-Images-con">
        <h1 style={{ color: "white" }}>
  {formatSlugToText(Path)}
</h1>
        </div>
      </section>
      <div className="container">
        <div className="top-bottom">
          <div className="Room-Details-Head-Main-con">
            <h2 style={{color: "black"}}>{foundSubservice.roomName}</h2>
           
          </div>
          <div className="Room-Details-Head-Details-con">
            {/* <p className="Room-Details-Page-Card-Main-Price">$300/Night</p> */}
            {/* <h4> ₹ {5000} / Weekday - ₹ {6000} / Weekend</h4> */}
            <h4> ₹ {foundSubservice.roomPrice} </h4>
          </div>
          <p style={{ color: "orange", textAlign: "left" }}>
              <FaStar /> <FaStar /> <FaStar /> <FaStar />
              <FaStar />
            </p>
        </div>
        <div className="imagesectionn">

          <div className="row">

            <div className="col-12 col-lg-6">
              {primaryImage && (
                <div className="Image-Section-Room-Details-con">
                  <img className="image-frst" src={primaryImage.roomImage}
                    alt={primaryImage.image_name} />
                </div>
              )}

            </div>

            <div className="col-12 col-lg-6 mt-4 mt-lg-0">
              <div className="row">
                {restImages.map((img) => (
                  <div key={img.image_id} className="col-6">
                    <div className="Image-Section-Room-Details-con-Second">
                      <img className="image-frst" src={img.roomImage} alt={img.image_name} />
                    </div>
                  </div>


                ))}
              </div>
            </div>
          </div>

        </div>
        <div className="top-bottom">

          <div className="row">

            <div className="col-md-6">
              <div className="Room-Details-Page-Description">
                <h3>Description</h3>
                {/* <p>{description || "No description available"}</p> */}
                {foundSubservice.roomShort_Des.map((desc) => (
                  <p className="lead" style={{ textAlign: 'justify' }}>{desc}</p>
                ))}
              </div>
            </div>
            <div className="col-md-6">
              <div className="Room-Details-Form">
                <h4 className="display-6">Room Reservation</h4>
                <form onSubmit={submitForm}>

                  <div className="row text-start">
                    <div className="col-6 p-3">
                      <label htmlFor="name" >Name </label>
                      <Input id="name" onChange={(e) => { setName(e.target.value) }}
                        value={name} type="text" required placeholder="Enter your Name " />
                    </div>
                    <div className="col-6 p-3">
                      <label htmlFor="email"  >Email </label>
                      <Input id="email" onChange={(e) => { setEmail(e.target.value) }}
                        value={email} required placeholder="Enter your Email " type="email" />
                    </div>
                  </div>
                  <div className="row text-start">
                    <div className="col-6 p-3">
                      <label htmlFor="mobilenumber" >Mobile number </label>
                      <InputNumber id="mobilenumber" required type="number" onChange={(contact) => setContact(contact)} value={contact} placeholder="Enter your Mobile Number" controls={false} style={{ width: '100%' }} />

                    </div>
                    <div className="col-6 p-3">
                      <label htmlFor="roomname" >Room Name </label>
                      <Input id="roomname" value={foundSubservice.roomName} type="text" readOnly />
                    </div>
                  </div>
                  <div className="Form-Date-Piker">
                    <div className="form-group">
                      <label htmlFor="fullName">Check In</label>
                      <DatePicker
                        format="DD MMM YYYY"
                        onChange={handleCheckInChange}
                        value={checkInDate}
                      // disabledDate={disabledCheckInDate}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="fullName">Check Out</label>
                      <DatePicker
                        format="DD MMM YYYY"
                        onChange={handleCheckOutChange}
                        value={checkOutDate}
                      // disabledDate={disabledCheckOutDate}
                      />
                    </div>
                  </div>

                  <div className="FormData-Person-Select my-2">
                    <div className="row">
                      <div className="col-6">
                        <div className="inputfiled mb-2">
                          <h6 className="leftclassname">Adults</h6>
                          <div className="containerer">
                            <div className="quantity">
                              <div
                                className="quantity__minus"
                                onClick={handleAdultDecrement}
                              >
                                <span>-</span>
                              </div>
                              <input
                                name="adultQuantity"
                                type="text"
                                className="quantity__input"
                                value={adultQuantity}
                                readOnly
                              />
                              <div
                                className="quantity__plus"
                                onClick={handleAdultIncrement}
                              >
                                <span>+</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-6">
                        <div className="inputfiled mb-2">
                          <h6 className="leftclassname">Rooms</h6>
                          <div className="containerer">
                            <div className="quantity">
                              <div
                                className="quantity__minus"
                                onClick={handleRoomsDecrement}
                              >
                                <span>-</span>
                              </div>
                              <input
                                name="roomsQuantity"
                                type="text"
                                className="quantity__input"
                                value={roomsQuantity}
                                readOnly
                              />
                              <div
                                className="quantity__plus"
                                onClick={handleRoomsIncrement}
                              >
                                <span>+</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mb-3 text-start">
                    <label htmlFor="message" >Message </label>
                    <TextArea rows={4} onChange={(e) => { setComment(e.target.value) }}
                      value={comment} type="textarea" id="message" />
                  </div>
                  <div className="CheckAvailability">
                    <button
                      type="submit"
                      // onClick={handleBooking}
                      onClick={() => setRoomname(foundSubservice.roomName)}
                      disabled={!checkInDate || !checkOutDate}
                    >
                      Check Availability
                    </button>
                  </div>
                </form>
              </div>
            </div>

          </div>
        </div>
        <div className="top-bottom">
          <div className="row">

            <div className="col-md-6">
              <div className="Room-Details-Facility-head">
                <h3>Our Facility</h3>
              </div>
              <div className="row">
                <div className="col-6">
                  <ul className="liststyle-review">
                    <li>Indoor Games</li>
                    <li>Outdoor Games</li>
                    <li>Free Wi-fi</li>
                    <li>Air conditione</li>
                    <li>Big Swimming Pools</li>
                    <li>Kids Pools</li>
                  </ul>
                </div>
                <div className="col-6">
                  <ul className="liststyle-review">
                    <li>Rain Dance</li>
                    <li>Waterfall</li>
                    <li>Kids play area</li>
                    <li>Shower bathtub</li>
                    <li>Air Conditioner</li>
                    <li>Shampoo and soap</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="Room-Details-Page-Description">
                <h3>Room Aminity</h3>
                <div className="row">
                  <div className="col-6">
                    <div className="ul styleul">
                      <li className="iconsection">
                        <span className="serviceicon">
                          <TbAirConditioning />
                        </span>
                        A/C
                      </li>
                      <li className="iconsection">
                        <span className="serviceicon">
                          <FaPersonSwimming />
                        </span>
                        Swiming Pool
                      </li>
                      <li className="iconsection">
                        <span className="serviceicon">
                          <RiFridgeLine />
                        </span>
                        Fridge
                      </li>
                      {/* <li className="iconsection">
                        <span className="serviceicon">
                          <BsFillSafe2Fill />
                        </span>
                        Safe Box
                      </li> */}
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="ul styleul">
                      <li className="iconsection">
                        <span className="serviceicon">
                          <FaWifi />
                        </span>
                        Wifi
                      </li>
                      <li className="iconsection">
                        <span className="serviceicon">
                          <PiTelevisionSimpleBold />
                        </span>
                        T.v
                      </li>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <Footer />
    </>
  );
};

export default RoomDetailsPage;


